import './assets/index.css';

// Suppress console.log unless debug mode is enabled.
// debugMode is controlled by VITE_DEBUG_MODE in your personal .env.local file.
// import.meta.env.DEV is only true for the dev server, not builds — use MODE instead.
// In production builds (MODE === 'production'), debug mode is permanently disabled.
const debugMode = import.meta.env.MODE !== 'production' && import.meta.env.VITE_DEBUG_MODE === 'true';
if (!debugMode) {
  console.log = () => {};
}

import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import { register } from 'swiper/element/bundle';
import { createApp } from 'vue';
import { watch } from 'vue'; // Import the watch function
import { createI18n } from 'vue-i18n';

import App from './App.vue';
import { messages } from './locales';
import router from './router';

const pinia = createPinia();
const head = createHead();

register();

// Retrieve the saved locale from localStorage, or default to 'da'
const savedLocale = localStorage.getItem('selectedLocale') || 'da';

const i18n = createI18n({
  legacy: false,
  locale: savedLocale, // Use the saved locale
  fallbackLocale: 'en',
  messages,
});

const app = createApp(App);

// Watch for locale changes and save them to localStorage
watch(
  () => i18n.global.locale.value, // Access the raw value of the locale
  (newLocale: string) => {
    localStorage.setItem('selectedLocale', newLocale);
  }
);

app.use(head);

app.use(pinia);
app.use(router);
app.use(i18n);

app.mount('#app');
